import React from 'react';
import { Field } from 'redux-form';
import { map } from 'ramda';
import PropTypes from 'prop-types';
import { ButtonWithLoader, Col, Row, Label, RFFormInput, PaperContent } from 'virtues-bootstrap';
import { PASSWORD_LENGHT_MIN } from 'constants/forms';
import s from './styles.module.scss';

const formRows = [
  {
    label: 'changePassword.currentPassword',
    name: 'currentPassword',
  },
  {
    label: 'changePassword.newPassword',
    name: 'newPassword',
  },
  {
    label: 'changePassword.confirmNewPassword',
    name: 'confirmNewPassword',
  },
];

const ChangePassword = ({ handleSubmit, pristine, submitting, t }) => (
  <PaperContent>
    <form onSubmit={handleSubmit}>
      <p>{t('changePassword.info', { minLength: PASSWORD_LENGHT_MIN })}</p>
      {map(
        ({ label, name }) => (
          <Row key={name}>
            <Col sm={5} md={5} lg={4}>
              <Label className={s.label} required>
                {t(label)}
              </Label>
            </Col>
            <Col sm={7} md={6} lg={5}>
              <Field
                spellCheck={false}
                className={s.passField}
                autoComplete="off"
                component={RFFormInput}
                name={name}
                placeholder="••••••••"
                type="text"
              />
            </Col>
          </Row>
        ),
        formRows,
      )}
      <div className={s.footer}>
        <ButtonWithLoader disabled={pristine} loading={submitting} type="submit">
          {t('buttons.submit')}
        </ButtonWithLoader>
      </div>
    </form>
  </PaperContent>
);

ChangePassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default ChangePassword;
